<template lang="html">
  <div>
    <form>
      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              v-validate="'required'"
              :error-messages="errors.collect('name')"
              data-vv-name="name"                
              label="Name"
            />
          </v-col>

          <v-col cols="12">
            <v-autocomplete 
              v-model="jobGrade"
              v-validate="'required'"
              :items="jobGrades"
              label="Job Grade"
              item-text="name"
              item-value="id"
              :error-messages="errors.collect('jobGrade')"
              data-vv-name="jobGrade"
              data-vv-as="job grade"
            />
          </v-col>
        </v-row> 
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            class="px-10"
            @click="closeDialog"
          >
            Close
          </v-btn>
          <v-btn
            color="hrissecondary"   
            class="white--text px-10"       
            @click="goNext"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-container>
    </form>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        name: '',
        jobGrade: null,
        jobGrades: [],
      
      }
    },
    mounted () {
      this.loadJobGrades()
    },
    methods: {
      loadJobGrades () {
        this.$api.jobGrades().list()
          .then(res => {
            this.jobGrades = res.data
          })
      },
      goNext () {
        this.$validator.validateAll().then((result) => {
          if (!result) return 

          this.$emit('next-step')
        })
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
      getFormData () {
        return {
          name: this.name,     
          job_grade_id: this.jobGrade,   
        }
      },
    },
  }
</script>
